import cookie from 'vue-cookies'

const isLoggedIn = () => cookie.isKey('msuid');
const authStatus = state => state.status;

export default {
    isLoggedIn,
    authStatus
}